/*global jQuery, subscribeToCalendars*/
( function ( $ )
{
    /// <summary>
    /// Agenda Widget
    /// Defines a jQuery UI widget to manage agenda sections.
    /// </summary>
    $.widget("ui.AgendaCalendar",
    {
        options:
        {
            /// <summary>
            /// Base link supplying the calendar feed subscription dialog.
            /// </summary>
            SubscribeUrl: null,
            /// <summary>
            /// Ajax link that provides events for the selected/next/previous month.
            /// </summary>
            AgendaUrl: null,
            /// <summary>
            /// Callback method used add extra post data before loading new events via ajax.
            /// </summary>
            MergeExtraPostData: null,
            /// <summary>
            /// Html to display instead of event while processing a new ajax request. aka. busy message.
            /// </summary>
            LoadingHTML: '<div class="fbcms_calendar_loading">'
                + '<img src="/img/spacer.gif" alt="Loading Events..." title="Loading Events..."/>'
                + '<div>Loading Events...</div>'
                + '</div>',
            /// <summary>
            /// Initially selected month.
            /// </summary>
            SelectedMonth: null,
            /// <summary>
            /// Use Event Popups
            /// </summary>
            UseEventPopups: true,
            /// <summary>
            /// Bind iCalFeed Scubscribe button.
            /// </summary>
            BindSubscribeButton: true
        },
        /// <summary>
        /// Widget destroyed.
        /// </summary>
        _destroy: function ()
        {
            return undefined;
        },
        /// <summary>
        /// Widget initializating.
        /// </summary>
        _init: function ()
        {
            return undefined;
        },
        /// <summary>
        /// Creating this widget.
        /// </summary>
        _create: function ()
        {
            var self, jElement;

            self = this;
            jElement = $(self.element);

            // month drop list changed.
            jElement.on('change', 'select[name=month]', function (/*e*/)
            {
                self.ChangeMonth($(this).val());
            });

            // clicked the previous button.
            jElement.on('click', '.previous_button', function (e)
            {
                e.preventDefault();
                self.ChangeMonth(null, 'Previous');
            });

            // clicked the next button.
            jElement.on('click', '.next_button', function (e)
            {
                e.preventDefault();
                self.ChangeMonth(null, 'Next');
            });

            if (self.options.BindSubscribeButton === true)
            {
                // clicked the show feed button.
                jElement.on('click', '.ical_show_button', function (e)
                {
                    e.preventDefault();
                    subscribeToCalendars( self.options.SubscribeUrl );
                });
            }

            self._setupTooltips();
        },
        _setupTooltips: function ()
        {
            var self, jElement;
            self = this;
            jElement = $(self.element);
            if (self.options.UseEventPopups === false)
            {
                return;
            }
            jElement.find('.event_row')
                        .vptooltip({
                            fetchContentElementCallback: function ( clickedObj )
                            {
                                return $(clickedObj).find('.event_details').get(0);
                            }
                        });
        },
        Refresh: function ()
        {
            this.ChangeMonth();
        },

        /// <summary>
        /// Returns the current selected month.
        /// </summary>
        GetSelectedMonth: function (/*aDateString*/)
        {
            return this.options.SelectedMonth;
        },
        /// <summary>
        /// Processes a button click and/or month drop change.
        /// The default behavior is the load the updated event table from the 
        /// AgendaUrl. 
        /// </summary>
        ChangeMonth: function (aSelectedMonth, aButtonClicked, aMergeExtraPostData)
        {
            var self, jElement, lMyData;
            self = this;
            jElement = $(self.element);

            if (aSelectedMonth !== undefined && aSelectedMonth !== null)
            {
                self.options.SelectedMonth = aSelectedMonth;
            }

            lMyData = {
                ButtonClicked: aButtonClicked,
                Month: self.options.SelectedMonth,
                'rndm': Math.random()
            };

            if (typeof aMergeExtraPostData === 'function')
            {
                lMyData = aMergeExtraPostData(lMyData);
            }
            else if (typeof self.options.MergeExtraPostData === 'function')
            {
                lMyData = self.options.MergeExtraPostData(lMyData);
            }

            jElement.html(self.options.LoadingHTML);
            $.ajax(self.options.AgendaUrl, {
                success: function (data, textStatus, jqXHR) //ignore jslint
                {
                    jElement.html(data);
                    self.options.SelectedMonth = jElement.find("input.selected_month").val();
                    self._setupTooltips();
                },
                error: function ( jqXHR, textStatus, errorThrown )//ignore jslint
                {
                    jElement.html(self.options.ErrorHTML);
                },
                data: lMyData,
                type: 'POST'
            });
        }
    });
}(jQuery));